import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class OrderFulfillmentLinesViewCtrl implements IController {

  order: any;

  public selectedLine:any;
  public isLineSelected:boolean;

  constructor() {
  }

  $onInit() {
    if(this.order.fulfillmentLines.length){
      //select first line by default
      this.selectedLine=this.order.fulfillmentLines[0];
      this.isLineSelected=true;
    }
    else{
      this.isLineSelected=false;
    }
  }
  onFulfillmentLineSelected(selectedLine){
    this.selectedLine = !_.isEqual(selectedLine, this.selectedLine) ? selectedLine : undefined;

  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('orderFulfillmentLinesView', {
    bindings: {
      order:'<',
    },
    template: require('./order-fulfillment-lines-view.html').default,
    controller: OrderFulfillmentLinesViewCtrl
  });
